import { render, staticRenderFns } from "./ParcelIntro.vue?vue&type=template&id=11157b30&"
import script from "./ParcelIntro.vue?vue&type=script&lang=js&"
export * from "./ParcelIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports